class Line
{
    public p1x: number;
    public p1y: number;
    public p2x: number;
    public p2y: number;
    public ppx: number;
    public ppy: number;
    public len: number;
    public collided: boolean;
    public remove: boolean;
    public kind: string;

    constructor(p1x: number, p1y: number, p2x: number, p2y: number)
    {
        this.p1x = p1x;
        this.p1y = p1y;
        this.p2x = p2x;
        this.p2y = p2y;
        this.kind = 'physline'
        this.ppx = p2x - p1x;
        this.ppy = p2y - p1y;

        this.len = Math.sqrt(Math.pow(this.ppx, 2) + Math.pow(this.ppy, 2));

        this.collided = false;
        this.remove = false;
    }
}

export default Line;